import { FriendShareRow } from "./FriendShareRow";
import { PaginationFooter } from "../../../components/ui/pagination-footer";
import { usePagination } from "../../../hooks/use-pagination";

const FRIENDS_PAGE_SIZE = 10;

/**
 * The "Your friends" section of the Friends & Groups page. Paginates the friends
 * grid at 10 per page; the prev/next controls only appear once there is an 11th
 * friend (usePagination + PaginationFooter self-hide at a single page). All
 * paging is client-side — the friends list is already loaded in full.
 */
export function FriendsListSection({
  friends,
  sharesByViewerId,
  onView,
  onShare,
  onRemove,
}) {
  const list = Array.isArray(friends) ? friends : [];
  const pager = usePagination(list, { pageSize: FRIENDS_PAGE_SIZE });

  return (
    <section className="rounded-2xl border border-slate-200/70 p-4 dark:border-slate-700">
      <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-200">
        Your friends
      </h3>
      {list.length === 0 && (
        <div className="mt-3 rounded-2xl border border-dashed border-slate-200 bg-slate-50 p-6 text-center text-xs text-slate-500 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-400">
          No friends yet. Send a request to get started.
        </div>
      )}
      {list.length > 0 && (
        <>
          <div className="mt-3 grid gap-2 sm:grid-cols-2">
            {pager.pageItems.map((friend) => {
              const activeShare = friend.uid
                ? sharesByViewerId?.[friend.uid]
                : null;
              return (
                <FriendShareRow
                  key={friend.email}
                  friend={friend}
                  isSharing={Boolean(activeShare)}
                  onShareClick={onShare}
                  onViewClick={onView}
                  onRemoveClick={onRemove}
                />
              );
            })}
          </div>
          <PaginationFooter
            page={pager.page}
            pageCount={pager.pageCount}
            rangeStart={pager.rangeStart}
            rangeEnd={pager.rangeEnd}
            total={pager.total}
            hasPrev={pager.hasPrev}
            hasNext={pager.hasNext}
            onPrev={pager.goPrev}
            onNext={pager.goNext}
            label="Friends"
            itemNoun="friend"
          />
        </>
      )}
    </section>
  );
}
